import React from 'react';
import {
  Box,
  Text,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const AchievementPopup = ({ achievement }) => {
  const bgColor = useColorModeValue('yellow.100', 'yellow.900');
  
  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -100, opacity: 0 }}
    >
      <Box
        position="fixed"
        top="20px"
        left="50%"
        transform="translateX(-50%)"
        bg={bgColor}
        p={4}
        borderRadius="lg"
        boxShadow="xl"
        zIndex="tooltip"
      >
        <VStack spacing={2}>
          <Text fontSize="2xl">{achievement.icon}</Text>
          <Text fontWeight="bold">{achievement.name}</Text>
          <Text fontSize="sm">{achievement.description}</Text>
        </VStack>
      </Box>
    </motion.div>
  );
};

export default AchievementPopup; 